'use client';

import React from 'react';

const shimmerClass = 'animate-pulse bg-gradient-to-r from-[#1a172d] via-[#201d38] to-[#1a172d]';

function HeroWidgetSkeleton() {
  return (
    <div className="container mx-auto px-4 py-16 md:py-24" aria-hidden="true">
      <div className="flex flex-col md:flex-row gap-12">
        <div className="flex-1 space-y-6">
          <div className={`${shimmerClass} h-4 w-48 rounded-full opacity-70`} />
          <div className={`${shimmerClass} h-10 md:h-12 w-5/6 rounded-lg`} />
          <div className={`${shimmerClass} h-4 w-3/4 rounded-lg`} />
          <div className="space-y-3 pt-4">
            <div className="flex items-center gap-2">
              <span className={`${shimmerClass} h-2 w-2 rounded-full`} />
              <span className={`${shimmerClass} h-3 w-44 rounded-lg`} />
            </div>
            <div className="flex items-center gap-2">
              <span className={`${shimmerClass} h-2 w-2 rounded-full`} />
              <span className={`${shimmerClass} h-3 w-52 rounded-lg`} />
            </div>
          </div>
        </div>

        <div className="flex-1">
          <div className="rounded-xl border border-[#6A3683]/30 bg-[#110f26]/80 p-6 shadow-xl shadow-[#6A3683]/10">
            <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
              <div className="space-y-2">
                <div className={`${shimmerClass} h-3 w-32 rounded-full`} />
                <div className={`${shimmerClass} h-4 w-56 rounded-full`} />
              </div>
              <div className={`${shimmerClass} h-10 w-24 rounded-full`} />
            </div>

            <div className="mt-6 space-y-4">
              <div className={`${shimmerClass} h-12 w-full rounded-lg`} />
              <div className={`${shimmerClass} h-12 w-full rounded-lg`} />
            </div>

            <div className="mt-6 space-y-3">
              <div className={`${shimmerClass} h-3 w-3/4 rounded-lg`} />
              <div className={`${shimmerClass} h-3 w-2/3 rounded-lg`} />
            </div>

            <div className="mt-8 space-y-3">
              <div className={`${shimmerClass} h-14 w-full rounded-lg`} />
              <div className={`${shimmerClass} h-16 w-full rounded-lg`} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroWidgetSkeleton;

